<div class="sidebar-inner-container">
  <div class="logo">
    <div *ngIf="!isCollapsed; else elseBlock">
      <a class="full-width-link" [routerLink]="">
        <img src="images/logo.png" alt="Matrix Logo" width="100" height="auto" />
      </a>
    </div>
    <ng-template #elseBlock>
      <div nz-flex [nzJustify]="'center'" [nzAlign]="'center'">
        <img src="images/favicon.png" alt="favicon Logo" width="32" height="32" />
      </div>
    </ng-template>
  </div>
  <div class="sidemenu">
    <cdk-virtual-scroll-viewport itemSize="50" class="example-viewport">
      <ul nz-menu nzMode="inline">
        <ng-container *ngFor="let detail of sideBarlist">
          <li
            nz-menu-item
            [routerLink]="detail.path"
            [class.ant-menu-item-selected]="isActive(detail.path)"
            [nz-tooltip]="isCollapsed ? detail.title : null"
            nzTooltipPlacement="right"
          >
            <div nz-flex [nzJustify]="'center'" *ngIf="isCollapsed; else elseBlock">
              <i class="{{ detail.icon }}" style="font-size: 15px; width: 18px;"></i>
            </div>
            <ng-template #elseBlock>
              <i class="{{ detail.icon }}" style="font-size: 15px; width: 18px;"></i>
            </ng-template>
            <span class="ms-2 menu-title" *ngIf="!isCollapsed">{{ detail.title }} </span>
          </li>
        </ng-container>
      </ul>
    </cdk-virtual-scroll-viewport>
  </div>
</div>
